import { Injectable, OnDestroy, inject } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { PartnerModel, VoivodeshipModel } from '../model';
import { HttpService } from './http.service';

@Injectable()
export class PartnersService implements OnDestroy {
    private httpService = inject(HttpService);

    partners$ = new BehaviorSubject<PartnerModel[]>([]);
    voivodeships$ = new BehaviorSubject<VoivodeshipModel[]>([]);

    private subscriptions$ = new Subscription();

    init(): void {
        this.subscriptions$.add(
            this.httpService
                .getPartners()
                .pipe(tap((data) => this.partners$.next(data)))
                .subscribe(),
        );

        this.subscriptions$.add(
            this.httpService
                .getVoivodeships()
                .pipe(tap((data) => this.voivodeships$.next(data)))
                .subscribe(),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions$.unsubscribe();
    }
}
